import { FunctionalComponent, h } from "@stencil/core";

interface SidebarTogglerButtonProps {
    iconName: string;
    label: string;
    key: string;
    tabTarget: string;
    expanTogglerButton: (e: Event) => void;
    retractTogglerButton: (e: Event) => void;
    triggerActiveState: (e: Event) => void;
}

export const SidebarTogglerButton: FunctionalComponent<SidebarTogglerButtonProps> = ({
    iconName,
    label,
    key,
    tabTarget,
    expanTogglerButton,
    retractTogglerButton,
    triggerActiveState,
}) => (
    <button
        data-ux-tab-target={tabTarget}
        type="button"
        class="ux-button ux-button--green"
        onMouseEnter={expanTogglerButton}
        onMouseLeave={retractTogglerButton}
        onClick={triggerActiveState}
        key={key}
    >
        <ux-icon name={iconName} weight="bold"></ux-icon>
        <span>{label}</span>
    </button>
);
